// extracted by mini-css-extract-plugin
export default {"root":"customInput_root__JV-iY"};